import {FC, useEffect, useState} from "react";

import {
    TextField,
    Autocomplete,
    Box,
    Paper,
    Checkbox,
    FormControlLabel,
    Divider
} from "@mui/material";

interface IMultiSelectProps {
    items: any[],
    label: string,
    selectAllLabel: string,
    fieldName: string,
    setValue: Function,
    errorMessage?: string,
    clearErrors: Function
    disabled?: boolean
}



export const MultiSelect = ({items, label, selectAllLabel, setValue, fieldName, errorMessage, clearErrors, disabled} :IMultiSelectProps) => {

    const [columns, setColumns] = useState<any[]>([]);
    const [selectAll, setSelectAll] = useState<boolean>(false);

    const handleToggleSelectAll = () => {
        clearErrors(fieldName);
        setSelectAll((prev) => {
            if (!prev) {
                setColumns([...items]);
                setValue(fieldName, [...items]);
            }
            else {
                setColumns([]);
                setValue(fieldName, []);
            }
            return !prev;
        });
    };


    useEffect(() => {
        if (items.length === 0) {
            setColumns([]);
            setSelectAll(false);
            setValue(fieldName, []);
        }
    }, [items]);

    return (
        <Autocomplete
            id={"autocomplete_with_select_all"}
            multiple
            limitTags={3}
            options={items}
            fullWidth
            disableCloseOnSelect
            blurOnSelect={false}
            freeSolo={false}
            value={columns}
            disabled={disabled}
            onChange={(_e, value, reason) => {
                clearErrors(fieldName);
                if (reason === "clear" || reason === "removeOption")
                    setSelectAll(false);
                if (reason === "selectOption" && value.length === items.length)
                    setSelectAll(true);
                setColumns(value);
                setValue(fieldName, value);
            }}
            renderInput={(params) => (
                <TextField {...params} label={label} variant="standard" helperText={errorMessage} error={!!errorMessage}/>
            )}
            renderOption={(props, option, { selected }) => (
                <li {...props}>
                    <Checkbox
                        checked={selected}
                        color={"accent"}
                    />
                    {option}
                </li>
            )}
            PaperComponent={(paperProps) => {
                const { children, ...restPaperProps } = paperProps;
                return (
                    <Paper {...restPaperProps}>
                        <Box
                            onMouseDown={(e) => e.preventDefault()} // prevent blur
                            pl={3.2}
                            py={0.5}
                        >
                            <FormControlLabel
                                onClick={(e) => {
                                    e.preventDefault(); // prevent blur
                                    handleToggleSelectAll();
                                }}
                                label={selectAllLabel}
                                control={
                                    <Checkbox id="select-all-checkbox" checked={selectAll} color={"accent"} indeterminate={
                                        columns.length > 0 && columns.length < items.length
                                    }/>
                                }
                            />
                        </Box>
                        <Divider />
                        {children}
                    </Paper>
                );
            }}
        />
    );
};

export default MultiSelect;
